import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-process-pages',
  templateUrl: './auth-process-pages.component.html',
  styleUrls: ['./auth-process-pages.component.scss'],
})
export class AuthProcessPagesComponent {}
